import { loginRequest, apiConfig } from "../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "../msalInstance";
import { toApiError } from "./apiError";
import axios from "axios";

export async function callApi(bodyData) {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called.",
    );
  }

  const handleAcquireTokenSilentError = (error) => {
    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      msalInstance.acquireTokenRedirect(loginRequest);
      throw new Error("Interaction required to acquire a new auth token.");
    }
    console.warn("Other silent token error: ", error);
    throw new Error("handleAcquireTokenSilentError");
  };

  const response = await msalInstance
    .acquireTokenSilent({
      ...loginRequest,
      account: account,
    })
    .catch(handleAcquireTokenSilentError);

  const accessToken = response.accessToken;
  const bearer = `Bearer ${accessToken}`;

  const axiosHeaders = {
    headers: {
      Authorization: bearer,
      "Content-Type": "application/json",
    },
  };

  const data = JSON.stringify(bodyData);

  try {
    return await axios.post(apiConfig.uri, data, axiosHeaders);
  } catch (error) {
    throw await toApiError(error);
  }
}
